import { useCallback, useEffect, useMemo, useState } from 'react'
import { useTranslations } from '@/core/translation'
import { PriceRangeFilterResponsiveProps } from './PriceRangeFilterResponsive.types'

export const usePriceRangeFilterResponsiveController = ({
  min,
  max,
  value,
  onChange,
}: PriceRangeFilterResponsiveProps) => {
  const t = useTranslations('components')

  const hasValue = (value.min !== min || value.max !== max) && value.min !== 0 && value.max !== 0

  const [isDrawerOpen, setIsDrawerOpen] = useState(false)
  const [intermediateValue, setIntermediateValue] = useState<
    PriceRangeFilterResponsiveProps['value']
  >({ ...value })

  const closeDrawer = useCallback(() => {
    setIsDrawerOpen(false)
    setIntermediateValue(value)
  }, [value])

  const onApply = useCallback(() => {
    onChange?.({ ...intermediateValue })

    setIsDrawerOpen(false)
  }, [onChange, intermediateValue])

  // sync value changes from parent
  useEffect(() => {
    setIntermediateValue({ ...value })
  }, [value])

  const displayLabel = useMemo(() => {
    if (!hasValue) return t('filters.price')

    return `$${value.min} - $${value.max}`
  }, [hasValue, t, value.max, value.min])

  return {
    hasValue,
    displayLabel,
    isDrawerOpen,
    setIsDrawerOpen,
    closeDrawer,
    onApply,
    intermediateValue,
    setIntermediateValue,
  }
}
